import { type LegalBlock, type LegalPageName, legalDocuments } from '../content/legal';

function LineBreaks({ text }: { text: string }) {
  return <span style={{ whiteSpace: 'pre-line' }}>{text}</span>;
}

function LegalContentBlock({ block }: { block: LegalBlock }) {
  const text =
    block.strongFrom === undefined ? (
      <LineBreaks text={block.text} />
    ) : (
      <>
        {block.text.slice(0, block.strongFrom)}
        <strong>
          <LineBreaks text={block.text.slice(block.strongFrom)} />
        </strong>
      </>
    );

  return (
    <div
      className={`padding-bottom ${block.kind === 'subheading' ? 'padding-small' : 'padding-medium'}`}
    >
      {block.kind === 'paragraph' && (
        <p>
          {text}
          {block.links?.map((link) => (
            <span key={link.href}>
              {' '}
              <a href={link.href}>{link.label}</a>.
            </span>
          ))}
        </p>
      )}
      {block.kind === 'heading' && <h2 className="heading-style-h4-3">{text}</h2>}
      {block.kind === 'subheading' && <h3 className="heading-style-h6-2">{text}</h3>}
    </div>
  );
}

export function LegalPage({ page }: { page: LegalPageName }) {
  const document = legalDocuments[page];

  return (
    <main id="main-content" className="main-wrapper">
      <section className="section_heading-h1">
        <div className="padding-global">
          <div className="container-small">
            <div className="padding-section-custom">
              <div className="text-align-center">
                <p className="text-size-medium-3 text-color-grey">{document.eyebrow}</p>
                <div className="margin-top margin-small">
                  <h1 className="heading-large-3">{document.title}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={document.sectionClassName}>
        <div className="padding-global">
          <div className="container-large">
            <div className="padding-section-smalltop-largebottom">
              <div className="max-width-large align-center">
                {document.blocks.map((block) => (
                  <LegalContentBlock key={block.text} block={block} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
